
import AppSellCategoryEditModal from "@/components/settings-default/SellCategoryEditModal.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			categories: DossierConfigService.getSellCategories(),
			toEditCategory: 0,
			path: [{
				to: "/settings/sales", value: this.$ct("sale/purchase")
			},     {value: this.$ct("sell-categories")}] as IBreadCrumb[],
		};
	},
	methods: {
		closeModal() {
			this.toEditCategory = 0;
		},
		saved() {
			this.categories = DossierConfigService.getSellCategories();
		},
		onEditClicked(catNumber:number) {
			this.toEditCategory = catNumber;
		}
	},
	components: {
		AppSellCategoryEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
